/**
 * all commonly used keywords, variable names will be stored here
 */
export const REFRESH_TOKEN = "refresh-token";
export const AUTH_TOKEN = "auth-token";
export const COMPLETED_STEP = "completed-step";